(function () {
  'use strict';

  angular
    .module('camadaValor')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('root.camadaValor', {
        url: '/camada-valor/home',
        views: {
          'content@': {
            templateUrl: 'camada-valor/home/camada-valor-home.tpl.html',
            controller: 'CamadaValorHomeCtrl',
            controllerAs: 'camadaValorHome'
          }
        },
        data: {
          role: 'CAMADA_VALOR_VISUALIZAR'
        }
      })
      .state('root.camadaValorCadastro', {
        url: '/camada-valor/cadastro',
        views: {
          'content@': {
            templateUrl: 'camada-valor/cadastro/camada-valor-cadastro.tpl.html',
            controller: 'CamadaValorCadastroCtrl',
            controllerAs: 'camadaValorCadastro'
          }
        },
        data: {
          role: 'CAMADA_VALOR_VISUALIZAR'
        }
      })
      .state('root.camadaValorCadastroHelpTassi', {
        url: '/camada-valor/cadastro/help-tassi',
        views: {
          'content@': {
            templateUrl: 'camada-valor/cadastro/camada-valor-cadastro.tpl.html',
            controller: 'CamadaValorCadastroCtrl',
            controllerAs: 'camadaValorCadastro'
          }
        },
        data: {
          role: 'CAMADA_VALOR_VISUALIZAR'
        }
      })
      .state('root.camadaValorGerenciar', {
        url: '/camada-valor/gerenciar',
        views: {
          'content@': {
            templateUrl: 'camada-valor/cadastro/camada-valor-cadastro.tpl.html',
            controller: 'CamadaValorCadastroCtrl',
            controllerAs: 'camadaValorCadastro'
          }
        },
        data: {
          role: 'CAMADA_VALOR_EDITAR'
        }
      })
      .state('root.informativoCamadaValor', {
        url: '/camada-valor/informativo?uo=',
        views: {
          'content@': {
            templateUrl: 'camada-valor/informativo/camada-valor-informativo.tpl.html',
            controller: 'CamadaValorInformativoCtrl',
            controllerAs: 'camadaValorInformativo'
          }
        }
      });
  }
}());
